export class HeatMapFontManagerResult {
}
